import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Photo treated deliberately: clipped frame + slow parallax scale on scroll.
export const ParallaxImage = ({ src, alt, className = "", ratio = "aspect-[4/5]", rounded = "", objectPosition = "center" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.12, 1.06, 1.12]);

  return (
    <div
      ref={ref}
      className={`group relative overflow-hidden ${ratio} ${rounded} ${className}`}
      style={{ background: "var(--paper)" }}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y, scale, objectPosition }}
        className="absolute inset-0 h-full w-full object-cover transition-[filter] duration-700 will-change-transform"
      />
      <div className="pointer-events-none absolute inset-0 ring-1 ring-inset" style={{ borderColor: "var(--line)" }} />
    </div>
  );
};
